import { Component } from 'react';

import isEmpty from 'Lib/utilities/isEmpty';

class Paragraph extends Component {
    render() {
        const { value, emptyText, defaultValue, ...rest } = this.props;
        const val = isEmpty(value) ? defaultValue : value;

        if (isEmpty(val)) {
            return <span {...rest}>{emptyText}</span>;
        }

        return (
            <span {...rest}>
                {value.split('\n').map((item, key) => (
                    <span key={key}>
                        {item}
                        <br />
                    </span>
                ))}
            </span>
        );
    }
}

export default Paragraph;
